"use client";

import { AxiomWebVitals as NextAxiomWebVitals } from "next-axiom";
import { usePathname } from "next/navigation";
import { sanitizePathnameForTelemetry } from "@/lib/axiom/path";

/**
 * Sends App Router Web Vitals with an app-sanitized route template instead of
 * allowing next-axiom to infer and ingest raw browser pathnames.
 */
export function AxiomWebVitals() {
  const pathname = usePathname();
  const path = sanitizePathnameForTelemetry(pathname);

  return <NextAxiomWebVitals key={path} path={path} />;
}
